import React, {useEffect, useState} from 'react';
import {
    Card, 
    Row, 
    Col, 
    Descriptions, 
    Tag, 
    Table, 
    Button, 
    Space,
    message,
    Statistic
} from 'antd';
import {ArrowLeftOutlined, EditOutlined, EnvironmentOutlined, PrinterOutlined} from '@ant-design/icons';
import {useApi} from '../provider/ApiProvider';
import {useHistory, useParams} from 'react-router-dom';
import LayoutComponent from '../components/LayoutComponent';

const TargetLocationViewPage = () => {
    const {api} = useApi();
    const history = useHistory();
    const {id} = useParams();
    const [targetLocation, setTargetLocation] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTargetLocation();
    }, [id]);

    const fetchTargetLocation = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/targetLocationRouter/get/${id}`);
            if (response.status) {
                setTargetLocation(response.data);
            }
        } catch (error) {
            message.error('Hedef lokasyon yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const doorColumns = [
        {
            title: 'Kapı No',
            dataIndex: 'doorNumber',
            key: 'doorNumber',
            width: 100,
        },
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'QR Kodu',
            dataIndex: 'qr',
            key: 'qr',
        },
        {
            title: 'Tip',
            dataIndex: 'type',
            key: 'type',
            width: 120,
            render: (type) => (
                <Tag color={type === 'entrance' ? 'green' : 'red'}>
                    {type === 'entrance' ? 'Giriş' : 'Çıkış'}
                </Tag>
            )
        },
        {
            title: 'Durum',
            dataIndex: 'isActive',
            key: 'isActive',
            width: 100,
            render: (isActive) => (
                <Tag color={isActive ? 'green' : 'red'}>
                    {isActive ? 'Aktif' : 'Pasif'}
                </Tag>
            )
        }
    ];

    if (!targetLocation) {
        return (
            <LayoutComponent>
                <div style={{ padding: '24px' }}>
                    <Card loading={loading}>
                        <div>Yükleniyor...</div>
                    </Card>
                </div>
            </LayoutComponent>
        );
    }

    return (
        <LayoutComponent>
            <div style={{ padding: '24px' }}>
                <Card 
                    title="Hedef Lokasyon Detayları"
                    extra={
                        <Space>
                            <Button 
                                icon={<PrinterOutlined />}
                                type="primary"
                                onClick={() => history.push(`/target-locations/qr-print/${id}`)}
                            >
                                QR Yazdır
                            </Button>
                            <Button 
                                icon={<EnvironmentOutlined />}
                                onClick={() => {
                                    // Burada harita görüntüleme fonksiyonu eklenebilir
                                    message.info('Harita görüntüleme özelliği yakında eklenecek');
                                }}
                            >
                                Haritada Göster
                            </Button>
                            <Button 
                                type="primary"
                                icon={<EditOutlined />}
                                onClick={() => history.push(`/target-locations/edit/${id}`)}
                            >
                                Düzenle
                            </Button>
                            <Button 
                                icon={<ArrowLeftOutlined />} 
                                onClick={() => history.push('/target-locations')}
                            >
                                Geri Dön
                            </Button>
                        </Space>
                    }
                >
                    <Row gutter={16} style={{ marginBottom: '24px' }}>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Toplam Kapı"
                                    value={targetLocation.doors ? targetLocation.doors.length : 0}
                                    valueStyle={{ color: '#1890ff' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Giriş Kapısı"
                                    value={targetLocation.doors ? targetLocation.doors.filter(d => d.type === 'entrance').length : 0}
                                    valueStyle={{ color: '#52c41a' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Çıkış Kapısı"
                                    value={targetLocation.doors ? targetLocation.doors.filter(d => d.type === 'exit').length : 0}
                                    valueStyle={{ color: '#faad14' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Aktif Kapı"
                                    value={targetLocation.doors ? targetLocation.doors.filter(d => d.isActive).length : 0}
                                    valueStyle={{ color: '#722ed1' }}
                                />
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Card title="Temel Bilgiler" size="small">
                                <Descriptions column={1} size="small">
                                    <Descriptions.Item label="ID">{targetLocation.id}</Descriptions.Item>
                                    <Descriptions.Item label="Ad">{targetLocation.name}</Descriptions.Item>
                                    <Descriptions.Item label="Durum">
                                        <Tag color={targetLocation.isActive ? 'green' : 'red'}>
                                            {targetLocation.isActive ? 'Aktif' : 'Pasif'}
                                        </Tag>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Giriş Tipi">
                                        {targetLocation.login === 1 ? 'Tek Giriş' : 'Çoklu Giriş'}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card title="Koordinat Bilgileri" size="small">
                                <Descriptions column={1} size="small">
                                    <Descriptions.Item label="Enlem (Latitude)">
                                        {targetLocation.latitude}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Boylam (Longitude)">
                                        {targetLocation.longitude}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Yarıçap">
                                        {targetLocation.radius}m
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={16} style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <Card title="Renk Ayarları" size="small">
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                            <div 
                                                style={{ 
                                                    width: 20, 
                                                    height: 20, 
                                                    backgroundColor: targetLocation.color, 
                                                    borderRadius: 4,
                                                    marginRight: 8
                                                }} 
                                            />
                                            <span>Ana Renk: {targetLocation.color}</span>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                            <div 
                                                style={{ 
                                                    width: 20, 
                                                    height: 20, 
                                                    backgroundColor: targetLocation.fillColor, 
                                                    borderRadius: 4,
                                                    marginRight: 8
                                                }} 
                                            />
                                            <span>Dolgu: {targetLocation.fillColor}</span>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                            <div 
                                                style={{ 
                                                    width: 20, 
                                                    height: 20, 
                                                    backgroundColor: targetLocation.strokeColor, 
                                                    borderRadius: 4,
                                                    marginRight: 8
                                                }} 
                                            />
                                            <span>Çizgi: {targetLocation.strokeColor}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={16} style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <Card title="Kapılar" size="small">
                                <Table
                                    columns={doorColumns}
                                    dataSource={targetLocation.doors || []}
                                    rowKey="id"
                                    pagination={false}
                                    size="small"
                                />
                            </Card>
                        </Col>
                    </Row>
                </Card>
            </div>
        </LayoutComponent>
    );
};

export default TargetLocationViewPage;
